module.exports = __webpack_public_path__ + "img/pin_transport_blue.367327a8.svg";